/**
 * Fix Shopify Subscriptions widget - Force price recalculation (optimized)
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initSubscriptionFix();
  });

  function initSubscriptionFix() {
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        const variant = event.data.variant;
        if (variant) {
          forceSubscriptionUpdate(variant);
        }
      });
    }
  }

  function forceSubscriptionUpdate(variant) {
    // Find the currently selected radio
    const selectedRadio = document.querySelector('input[name^="purchaseOption"]:checked');
    if (!selectedRadio) return;

    const isSubscription = selectedRadio.getAttribute('data-radio-type') === 'selling_plan';
    
    // Find the price element to hide during update
    const priceElement = document.querySelector('[id^="price-"]');
    const wasVisible = priceElement && priceElement.style.visibility !== 'hidden';
    
    // Hide price during recalculation to prevent flicker
    if (priceElement && isSubscription) {
      priceElement.style.visibility = 'hidden';
    }
    
    // Update all radios with new variant prices
    const allRadios = document.querySelectorAll('input[name^="purchaseOption"]');
    allRadios.forEach(function(radio) {
      if (radio.getAttribute('data-radio-type') === 'one_time_purchase') {
        radio.setAttribute('data-variant-price', formatMoney(variant.price));
        radio.setAttribute('data-variant-id', variant.id);
      } else if (radio.getAttribute('data-radio-type') === 'selling_plan') {
        const subscriptionPrice = Math.round(variant.price * 0.8); // 20% off
        radio.setAttribute('data-variant-price', formatMoney(subscriptionPrice));
        radio.setAttribute('data-variant-compare-at-price', formatMoney(variant.price));
      }
    });

    // Force recalculation with minimal delay
    if (isSubscription) {
      const oneTimeRadio = document.querySelector('input[data-radio-type="one_time_purchase"]');
      if (oneTimeRadio) {
        oneTimeRadio.click();
        
        // Use requestAnimationFrame for smoother transition
        requestAnimationFrame(function() {
          selectedRadio.click();
          
          // Show price again after recalculation
          if (priceElement && wasVisible) {
            requestAnimationFrame(function() {
              priceElement.style.visibility = 'visible';
            });
          }
        });
      }
    } else {
      selectedRadio.click();
      if (priceElement && wasVisible) {
        priceElement.style.visibility = 'visible';
      }
    }
  }

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars} USD`;
  }
})();